var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('profile.Profile'))+" Page")]),_c('side-menus-container',{attrs:{"callBack":_vm.testCallback,"menus":_vm.menusData,"info":_vm.sectionInfo},on:{"update:menus":function($event){_vm.menusData=$event},"update:info":function($event){_vm.sectionInfo=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }